import {css} from 'lit';
export const styles = css`:host {
  --chat-msg-reply-border-color: var(--dark-text-secondary);

  display: flex;
  align-items: center;
  margin: var(--chat-form-reply-preview-margin);
  color: var(--chat-form-reply-preview-text-color);
}

ef-chat-message-reply {
  flex: 1;
}

button {
  width: var(--chat-form-submit-width);
  height: var(--chat-form-submit-height);
  margin-left: var(--chat-form-submit-margin-left);
  font-size: var(--chat-form-submit-font-size);
  background-color: transparent;
  color: inherit;
  border: none;
}

@media (hover: hover) {
    button:hover {
      opacity: 0.7;
    }
  }

button:active {
    opacity: 1;
  }
`;
export default styles;
